export function compareNullableText(first: string | null, second: string | null): number {
  if (first === null && second === null) return 0;
  if (first === null) return 1;
  if (second === null) return -1;
  return first.localeCompare(second, 'nl');
}

export function compareNullableDate(first: string | null, second: string | null): number {
  if (first === null && second === null) return 0;
  if (first === null) return 1;
  if (second === null) return -1;
  return new Date(first).getTime() - new Date(second).getTime();
}
